/// <amd-module name="Repos/Editor/Components/Shortcuts" />

export function unregisterDefaultKeyBindings(editor: monaco.editor.IEditor, keypressPart: string) {
    try {
        const keybindingService = (editor as any)._standaloneKeybindingService;
        const bindings = keybindingService._getResolver()._defaultKeybindings.filter((b: any) => b.keypressParts[0] == keypressPart);
        for (const binding of bindings) {
            keybindingService.addDynamicKeybinding(`-${binding.command}`, undefined, () => {});
        }
    } catch (error) {
        // This method is prone to fail as we depend on private elements of Monaco.
        // If it fails, nothing should break, just Ctrl-K may stop working.
        // In that case, we display the issue in Console so we realize and can fix it.
        console.warn(error);
    }
}
